import { Component, inject, signal } from '@angular/core';
import { Router, RouterOutlet, RouterModule } from '@angular/router';
import { AuthService } from './services/auth-service';
import { UserRole } from './models/user';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterModule, CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('characterCodex');
  auth = inject(AuthService);
  router = inject(Router);
  readonly userRole = UserRole;
  readonly isRoleSwitcherOpen = signal(false);
  readonly isMenuOpen = signal(false);

  constructor() {
    this.auth.restoreSession();
  }

  logout(): void {
    this.isRoleSwitcherOpen.set(false);
    this.auth.logout();
    this.router.navigate(['/home']);
  }

  toggleRoleSwitcher(): void {
    if (!this.auth.isLoggedIn() || !this.canSwitchRoles()) {
      return;
    }

    this.isRoleSwitcherOpen.update((isOpen) => !isOpen);
  }

  closeRoleSwitcher(): void {
    this.isRoleSwitcherOpen.set(false);
  }

  toggleMobileMenu(): void {
    this.isMenuOpen.update((isOpen) => !isOpen);
  }

  closeMobileMenu(): void {
    this.isMenuOpen.set(false);
  }

  switchRole(role: UserRole): void {
    this.auth.enterAs(role);
    this.closeRoleSwitcher();
    this.router.navigate(['/home']);
  }

  selectEntryRole(role: UserRole): void {
    this.auth.enterAs(role);
    this.router.navigate(['/home']);
  }

  canSwitchRoles(): boolean {
    return this.auth.availableRoles().length > 1;
  }

  shouldShowRoleSelectionModal(): boolean {
    return this.auth.isLoggedIn() && !this.auth.hasSelectedRole();
  }

  getRoleLabel(role: UserRole | null): string {
    switch (role) {
      case UserRole.Admin:
        return 'Admin';
      case UserRole.DungeonMaster:
        return 'Dungeon Master';
      case UserRole.Player:
        return 'Player';
      default:
        return 'Choose Role';
    }
  }

}
